/* ICE · segunda foto do card de produto (14/10/2026, v4: no tempo da Represent; 15/10 v6: alterna sozinha em loop).
   v4 (medido em representclo.com em 14/10): computador = mouse em cima troca na hora, fade de 0,3 s, sair volta em 0,3 s;
   celular = arrastar a foto pro lado (esquerda = modelo, direita = volta pro mockup), dois pontinhos avisam que tem outra imagem.
   v6 (pedido do Felipe 15/10): em todo lugar que tem card (home, coleções, Loja, grades da PDP), enquanto o card está na tela
   (pelo menos 60% visível, inclusive dentro das prateleiras que rolam pro lado) a foto alterna sozinha a cada 2 s:
   mockup -> modelo -> mockup -> ... Saiu da tela, para e volta pro mockup. Hover (computador) mostra o modelo enquanto o mouse
   estiver em cima. Arrastar no celular escolhe a foto e para o loop daquele card. Com "reduzir movimento" ligado, não alterna.
   Só começa depois que a 2ª imagem carregou. Cards marcados com data-alt (snippets/ice16-h-pcard e sections/ice16-cards).
   v7 (pedido do Felipe 15/10): na troca automática a foto escurece até o preto (0,25 s), troca no escuro e volta (0,25 s),
   pra dar impacto em vez de "corrido". Continua 2 s em cada foto. Hover e arrasto seguem com o fade normal (sem preto). */
(function () {
  if (window.__iceCardAlt) return;
  window.__iceCardAlt = 7;
  var PASSO = 2000; // ms em cada foto
  var ESCURO = 250; // ms pra ir ao preto (e o mesmo pra voltar)
  var css =
    '.h-pcard[data-alt] .h-ph>img,.i-pcard[data-alt] .i-ph>img{transition:opacity .3s ease,transform .5s}' +
    '.i-pcard[data-alt] .i-ph{position:relative;overflow:hidden}' +
    '.ice-alt{position:absolute;inset:0;z-index:1;opacity:0;transition:opacity .3s ease;pointer-events:none}' +
    '.ice-alt img{width:100%;height:100%;object-fit:cover;display:block}' +
    '.ice-preto{position:absolute;inset:0;z-index:1;background:#000;opacity:0;transition:opacity .25s ease;pointer-events:none}' +
    '.ice-alt-escuro .ice-preto{opacity:1}' +
    '.ice-alt-seco .ice-alt,.h-pcard.ice-alt-seco .h-ph>img,.i-pcard.ice-alt-seco .i-ph>img{transition:none!important}' +
    '.h-pcard .h-badge{z-index:2}' +
    '@media (hover:hover){' +
      '.h-pcard[data-alt]:hover .ice-alt,.i-pcard[data-alt]:hover .ice-alt{opacity:1}' +
      '.h-pcard[data-alt]:hover .h-ph>img,.i-pcard[data-alt]:hover .i-ph>img{opacity:0}' +
    '}' +
    '.ice-alt-on .ice-alt{opacity:1}' +
    '.h-pcard.ice-alt-on .h-ph>img,.i-pcard.ice-alt-on .i-ph>img{opacity:0}' +
    '.ice-dots{position:absolute;left:50%;bottom:8px;transform:translateX(-50%);z-index:3;display:flex;gap:5px;pointer-events:none}' +
    '.ice-dots i{width:5px;height:5px;border-radius:50%;background:rgba(238,235,227,.35);transition:background .3s}' +
    '.ice-dots i:first-child,.ice-alt-on .ice-dots i:last-child{background:rgba(238,235,227,.95)}' +
    '.ice-alt-on .ice-dots i:first-child{background:rgba(238,235,227,.35)}' +
    '@media (hover:hover){.ice-dots{display:none}}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var toque = window.matchMedia && !window.matchMedia('(hover: hover)').matches;
  var calmo = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function para(c, volta) {
    if (c.__iceI) { clearInterval(c.__iceI); c.__iceI = null; }
    if (c.__iceT) { clearTimeout(c.__iceT); c.__iceT = null; }
    if (c.__iceE) { clearTimeout(c.__iceE); c.__iceE = null; }
    c.classList.remove('ice-alt-escuro');
    if (volta) c.classList.remove('ice-alt-on');
  }
  // troca com escurecimento: vai ao preto, troca a foto seca (sem fade) no escuro, volta
  function troca(c) {
    if (c.__iceE) return;
    if (c.matches && c.matches(':hover')) { c.classList.toggle('ice-alt-on'); return; }
    c.classList.add('ice-alt-escuro');
    c.__iceE = setTimeout(function () {
      c.__iceE = null;
      if (!c.__iceVis || c.__iceManual) { c.classList.remove('ice-alt-escuro'); return; }
      c.classList.add('ice-alt-seco');
      c.classList.toggle('ice-alt-on');
      void c.offsetWidth;
      c.classList.remove('ice-alt-seco');
      c.classList.remove('ice-alt-escuro');
    }, ESCURO);
  }
  function roda(c) {
    if (c.__iceI || c.__iceT || c.__iceManual) return;
    var im = c.querySelector('.ice-alt img');
    if (!im) return;
    var inicia = function () {
      if (c.__iceI || !c.__iceVis || c.__iceManual) return;
      c.__iceT = setTimeout(function () {
        c.__iceT = null;
        if (!c.__iceVis || c.__iceManual) return;
        troca(c);
        c.__iceI = setInterval(function () { troca(c); }, PASSO);
      }, PASSO);
    };
    if (im.complete && im.naturalWidth) inicia();
    else { im.loading = 'eager'; im.addEventListener('load', inicia, { once: true }); }
  }

  var io = null;
  if (!calmo && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var c = e.target;
        if (e.isIntersecting && e.intersectionRatio >= 0.6) { c.__iceVis = true; roda(c); }
        else if (e.intersectionRatio < 0.1) { c.__iceVis = false; para(c, true); c.__iceManual = false; }
      });
    }, { threshold: [0, 0.1, 0.6] });
  }

  function prepara() {
    var cards = document.querySelectorAll('[data-alt]:not([data-alt-ok])');
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      c.setAttribute('data-alt-ok', '');
      var ph0 = c.querySelector('.h-ph,.i-ph');
      if (ph0 && !ph0.querySelector('.ice-preto')) {
        var pr = document.createElement('span');
        pr.className = 'ice-preto';
        pr.setAttribute('aria-hidden', 'true');
        ph0.appendChild(pr);
      }
      if (io) io.observe(c);
      if (!toque) continue;
      // celular: pontinhos + arrasto lateral na foto
      var ph = c.querySelector('.h-ph,.i-ph');
      if (!ph) continue;
      var d = document.createElement('span');
      d.className = 'ice-dots';
      d.setAttribute('aria-hidden', 'true');
      d.innerHTML = '<i></i><i></i>';
      ph.appendChild(d);
      liga(c, ph);
    }
  }
  function liga(card, ph) {
    var x0 = 0, y0 = 0, feito = false;
    ph.addEventListener('touchstart', function (e) {
      var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; feito = false;
    }, { passive: true });
    ph.addEventListener('touchmove', function (e) {
      if (feito) return;
      var t = e.touches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      if (Math.abs(dx) < 28 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
      feito = true;
      card.__iceManual = true;
      para(card, false);
      card.classList.toggle('ice-alt-on', dx < 0);
    }, { passive: true });
  }
  prepara();
  document.addEventListener('DOMContentLoaded', prepara);
  document.addEventListener('shopify:section:load', prepara);
  if ('MutationObserver' in window) {
    var mo_t = null;
    new MutationObserver(function () { clearTimeout(mo_t); mo_t = setTimeout(prepara, 150); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
})();
